import React, { useCallback } from 'react';

import { type MenuItemOnClick } from '@atlaskit/navigation-system/side-nav-items/button-menu-item';
import { FlyoutTrigger } from '@atlassian/entry-point-flyout';

import { useAnalyticsEvents } from '../../common/analytics/generated/use-analytics-events';

import { objectListFlyoutEntrypoint } from './flyout-menu-item-content/entrypoint';
import type { ObjectListFlyoutProps } from './types';

/**
 * Component that renders a list of items in a flyout menu with searching & filtering capabilities in the list.
 * Consumers can provide the items data via the useItems hook.
 */
export function ObjectListFlyout(props: ObjectListFlyoutProps) {
	const { label, icon, analyticsName, triggerRef, testId, onClick, onOpenChange } = props;
	const { fireEvent } = useAnalyticsEvents();

	const handleTriggerClick: MenuItemOnClick<HTMLButtonElement> = useCallback(
		(...args) => {
			fireEvent('ui.flyout.clicked.objectListFlyoutTrigger', {
				component: 'ObjectListFlyout',
				name: analyticsName ?? testId ?? null,
			});
			onClick?.(...args);
		},
		[analyticsName, fireEvent, onClick, testId],
	);

	return (
		<FlyoutTrigger
			entryPoint={objectListFlyoutEntrypoint}
			entryPointProps={props}
			triggerProps={{
				elemBefore: icon,
				onClick: handleTriggerClick,
				children: label,
				testId,
				triggerRef,
			}}
			onOpenChange={onOpenChange}
		/>
	);
}
